import { render, staticRenderFns } from "./PageInicio.vue?vue&type=template&id=572e55fa&"
import script from "./PageInicio.vue?vue&type=script&lang=js&"
export * from "./PageInicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports